module.exports = __webpack_public_path__ + "img/pic2.eedc62c7.png";